import React from 'react';
import PropTypes from 'prop-types';

function ItemTemplate({ file }) {
  return (
    <div className="flex items-center justify-between w-full gap-3" style={{ padding: '10px' }}>
      <div className="flex items-center gap-2 overflow-hidden">
        <span className="truncate">{file.name}</span>
        <small className="opacity-70">({Math.round(file.size / 1024)} KB)</small>
      </div>
    </div>
  );
}
ItemTemplate.propTypes = {
  file : PropTypes.object,
};

export default ItemTemplate;
